import { useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
    Sheet, SheetContent, SheetHeader, SheetTitle,
} from "@/components/ui/sheet";
import { Sparkle } from "@phosphor-icons/react";
import { openWidget, closeWidget } from "@/state/chat/chat.slice";
import ChatPanel from "./ChatPanel";

// Permissions that grant access to analytics-style data (mirrors the Reports gate).
const ALLOWED = ["ViewReports", "ViewDashboardStats", "Reports", "Settings"];

export default function AssistantWidget() {
    const dispatch = useDispatch();
    const { isOpen } = useSelector((state) => state.chat);
    const user = useSelector((state) => state.auth.user);

    const canUse = useMemo(() => {
        if (!user?.role?.permissions) return false;
        let perms = user.role.permissions;
        if (typeof perms === "string") {
            try { perms = JSON.parse(perms); } catch { return false; }
        }
        if (!Array.isArray(perms)) return false;
        if (user.role?.name?.toLowerCase?.().includes("admin")) return true;
        return perms.some((p) => ALLOWED.includes(p));
    }, [user]);

    if (!canUse) return null;

    return (
        <>
            {/* Floating launcher */}
            {!isOpen && (
                <button
                    onClick={() => dispatch(openWidget())}
                    aria-label="Open AI assistant"
                    className="fixed bottom-5 right-5 z-40 h-14 w-14 rounded-full bg-primary text-primary-foreground
                        shadow-lg flex items-center justify-center hover:scale-105 active:scale-95 transition-transform"
                >
                    <Sparkle className="h-6 w-6" weight="duotone" />
                </button>
            )}

            <Sheet open={isOpen} onOpenChange={(o) => (o ? dispatch(openWidget()) : dispatch(closeWidget()))}>
                <SheetContent
                    side="right"
                    className="w-full sm:max-w-xl lg:max-w-2xl p-0 flex flex-col gap-0"
                >
                    <SheetHeader className="px-4 py-3 border-b space-y-0">
                        <SheetTitle className="flex items-center gap-2 text-base">
                            <Sparkle className="h-5 w-5 text-primary" weight="duotone" />
                            AI Assistant
                        </SheetTitle>
                    </SheetHeader>
                    <div className="flex-1 min-h-0">
                        <ChatPanel />
                    </div>
                </SheetContent>
            </Sheet>
        </>
    );
}
